import PropTypes from 'prop-types';
import { createElement } from 'react';
import cx from 'classnames';

import './index.less';

function NavigationTitle({ title, children, icon, imageSrc, noMargin }) {
  return (
    <div className={cx('navigation-title', { 'navigation-title--noMargin': noMargin })}>
      {imageSrc && <img src={imageSrc} alt="image header" className="navigation-title__image" />}
      {createElement(icon || '', { className: 'navigation-title__icon' })}
      <div className="navigation-title__title">{title}</div>
      <div className="navigation-title__children">{children}</div>
    </div>
  );
}

NavigationTitle.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string.isRequired,
  icon: PropTypes.func,
  imageSrc: PropTypes.string,
  noMargin: PropTypes.bool,
};

NavigationTitle.defaultProps = {
  noMargin: false,
};

export default NavigationTitle;
